import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { commonHeaderStyle, commonStyle, rowStyle2 } from "../Utility/utility";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";

import "../style.css";
const GstinPopup = (props) => {
  const { open, onClose, selectedRecord, dialogName } = props;

  // Transform string array to objects for table display
  const formatDataForTable = (records) => {
    if (!records || !Array.isArray(records)) return [];
    
    // Handle case where records is an array with comma-separated string
    let allGstins = [];
    
    records.forEach(record => {
      if (typeof record === 'string' && record.includes(',')) {
        // Split comma-separated string into individual GSTINs
        const splitGstins = record.split(',').map(gstin => gstin.trim()).filter(gstin => gstin.length > 0);
        allGstins.push(...splitGstins);
      } else {
        // Single GSTIN
        allGstins.push(record.toString().trim());
      }
    });
    
    // Remove duplicates and create table objects
    const uniqueGstins = [...new Set(allGstins)];
    
    return uniqueGstins.map((gstin, index) => ({
      fileId: index + 1, // Unique key for each row
      gstin: gstin, // Individual GSTIN
      serialNo: index + 1 // Serial number
    }));
  };

  const columns = [
    {
      dataField: "serialNo",
      text: "Sr. No.",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        textAlign: "center",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "50%",
        textAlign: "center",
      },
    },
    {
      dataField: "gstin",
      text: "GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "50%",
      },
    },
  ];

  const columns2 = [
    {
      dataField: "serialNo",
      text: "Sr. No.",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        textAlign: "center",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "50%",
        textAlign: "center",
      },
    },
    {
      dataField: "gstin",
      text: "Return Period",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "50%",
      },
    },
  ];

  const tableData = formatDataForTable(selectedRecord);
  
  console.log("props.selectedRecord:", selectedRecord);
  console.log("Formatted table data:", tableData);

  return (
    <>
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="xs"
        open={open}
      >
        <MuiDialogTitle
          disableTypography
          style={{ color: "#4f2d7f", backgroundColor: "white" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div></div>
            <Typography variant="h6">{dialogName}</Typography>
            <CloseIcon
              onClick={() => onClose()}
              style={{ cursor: "pointer" }}
            />
          </div>
        </MuiDialogTitle>
        <MuiDialogContent
          dividers
          style={{ height: tableData?.length > 5 ? '15em' : 'auto', overflowY: "auto" }}
        >
          <div className="light-border-gstr2a2bnew-table">
            {tableData.length > 0 ? (
              <BootstrapTable
                keyField="fileId"
                data={tableData}
                columns={dialogName === 'Multiple Gstins' ? columns : columns2}
                rowStyle={rowStyle2}
              />
            ) : (
              <div
                style={{ padding: "20px", textAlign: "center", color: "#666" }}
              >
                No valid data found. GSTIN must be 15 characters and period must
                be in MM-YYYY format.
              </div>
            )}
          </div>
        </MuiDialogContent>
      </Dialog>
    </>
  );
};

export default GstinPopup;
